// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1or0P","title":"ClientCherryInfo_title__ey6ss","itemText":"ClientCherryInfo_itemText__3tz1u"};